/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Pole_DanceInputs */

const en_service_type_pole_dance = /** @type {(inputs: Service_Type_Pole_DanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole dance`)
};

const pl_service_type_pole_dance = /** @type {(inputs: Service_Type_Pole_DanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole dance`)
};

/**
* | output |
* | --- |
* | "Pole dance" |
*
* @param {Service_Type_Pole_DanceInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_pole_dance = /** @type {((inputs?: Service_Type_Pole_DanceInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Pole_DanceInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_pole_dance(inputs)
	return en_service_type_pole_dance(inputs)
});